import * as React from 'react';
import { t } from 'utils/localize';
import DetailsReadOnly from '../../../components/foundation/DetailsReadOnly/DetailsReadOnly';
import { localizedDateAtTimeString, localizedMediumDateOnlyString } from '../../../utils/dateUtils';
import { descriptionWithFallBack, projectPathWithFallBack } from '../../../utils/defaultMissingSelectors';

/*
  A view for displaying the details of a specific media entry that also includes a few items
  from the collection. Based on the DetailsReadOnly component.
*/
export interface IPhotoDetailsReadOnlyProps {
  isOpen: boolean;
  className?: string | object;
  photoTaken: number;
  uploadedBy: string;
  date: number;
  projectPath?: string;
  description?: string;
  onClose?: () => void;
  layer?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;
}

const PhotoDetailsReadOnly: React.FunctionComponent<IPhotoDetailsReadOnlyProps> = (props) => {
  return (
    <DetailsReadOnly
      className={props.className}
      isOpen={props.isOpen}
      onClose={props.onClose}
      title={t('Photo details')}
      layer={props.layer}
      data={[
        {
          rows: [
            { title: t('Photo taken'), detail: localizedDateAtTimeString(props.photoTaken, 'utc') },
            { title: t('Uploaded by'), detail: props.uploadedBy },
            { title: t('Date'), detail: localizedMediumDateOnlyString(props.date, 'utc') },
          ],
        },
        {
          rows: [
            { title: t('Project'), detail: projectPathWithFallBack(props.projectPath) },
            { title: t('Description'), detail: descriptionWithFallBack(props.description) },
          ],
        },
      ]}
    />
  );
};

export default PhotoDetailsReadOnly;
